import { Lci3SalesMetrics } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { ChartOptionsToBase64SvgOptions } from '@features/powerpoint';
import { salesLiftChartOptions } from '@components/Dashboard/SalesAttribution/SalesAttributionView/Summary/SalesLiftChart/salesLiftChartOptions';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

type SalesLiftChartItem = {
  name: string;
  sales: number;
  lift: number;
  confidenceLevel: number;
};

export const getSalesLiftChartSVG = (
  summary: Lci3SalesMetrics,
  width: number,
  height: number
): ChartOptionsToBase64SvgOptions => {
  const salesLiftChartData: SalesLiftChartItem[] = [
    {
      name: 'Overall',
      sales: summary.incrementalSales.total ?? 0,
      lift: summary.incrementalSalesLift.total ?? 0,
      confidenceLevel: summary.confidenceLevel.total ?? 0,
    },
    {
      name: 'In-Store',
      sales: summary.incrementalSales.inStore ?? 0,
      lift: summary.incrementalSalesLift.inStore ?? 0,
      confidenceLevel: summary.confidenceLevel.inStore ?? 0,
    },
    {
      name: 'E-Commerce',
      sales: summary.incrementalSales.online ?? 0,
      lift: summary.incrementalSalesLift.online ?? 0,
      confidenceLevel: summary.confidenceLevel.online ?? 0,
    },
  ];

  const salesLiftChartFullOptions: Highcharts.Options = {
    ...salesLiftChartOptions(salesLiftChartData, [
      unifiedPlatformColorPalette.chartLightBlue,
      unifiedPlatformColorPalette.chartLightGreen,
      unifiedPlatformColorPalette.chartDarkBlue,
    ]),
    chart: {
      type: 'column',
      height,
      width,
    },
  };

  return {
    chartOptions: salesLiftChartFullOptions,
    width,
    height,
  } satisfies ChartOptionsToBase64SvgOptions;
};
